import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';

import Clearfix from 'Common/Clearfix/Clearfix.jsx';
import Button from 'Common/CustomButtons/Button';
import { FormEditor } from 'Common/ReduxForm';
import FormGroup from 'Components/FormGroup/FormGroup';
import { requiredValidation } from 'Utils';

@reduxForm({
    form: 'settingData',
    enableReinitialize: true,
})
class SettingForm extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        pristine: PropTypes.bool,
        submitting: PropTypes.bool,
        initialValues: PropTypes.object,
    };

    getFields() {
        const { initialValues } = this.props;
        const fields = [];
        for (const alias in initialValues) {
            fields.push(
                <Field
                    withLabel
                    rowClassName="mm-form-field"
                    component={FormEditor}
                    validate={[requiredValidation]}
                    name={alias}
                    label={alias}
                    placeholder={alias}
                    key={alias}
                />
            );
        }

        return fields;
    }

    render() {
        const { pristine, submitting, handleSubmit } = this.props;

        return (
            <form
                onSubmit={ handleSubmit }
                id="settingData"
                className="form-wrapper"
            >
                <FormGroup required>
                    { this.getFields() }
                </FormGroup>
                <Button
                    color="success"
                    right
                    type="submit"
                    disabled={ pristine || submitting }
                >
                    <FormattedMessage id={'button.settings_general.update'} />
                </Button>
                <Clearfix/>
            </form>
        );
    }
}

export default SettingForm;



// WEBPACK FOOTER //
// ./src/layouts/Settings/components/SettingForm.jsx